import { render } from "./CrowdfundingBanner.vue?vue&type=template&id=5c5d8604"
import script from "./CrowdfundingBanner.vue?vue&type=script&lang=js"
export * from "./CrowdfundingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__